module.exports = __webpack_public_path__ + "static/pt-sans-v12-latin-700-3753a441923d9bd79d511de00bc2766e.woff2";